import { MapTo } from '@adobe/aem-react-editable-components';
import DebitCardFunding, { DebitCardFundingEditConfig } from './DebitCardFunding';

export default MapTo('cob-corp-acquisition/components/creditonebank/debit-card-funding')(DebitCardFunding, DebitCardFundingEditConfig);